<script setup lang="ts">
// @ts-expect-error raison: lib externe mal typée
import { onMounted, ref, defineProps, reactive, toRaw } from 'vue';
import { useToastStore } from '@/stores/toast.store';
import { formatAmount, formatDateFrench } from '@/utils';
import axios from 'axios';
import moment from 'moment';

const props = defineProps<{
    userId: number
}>();

const queryParams = reactive({
    pageNumber: 1,
    borneInf: '',
    borneSup: '',
    search: '',
    banque_id: null as any,
});
const loadingListing = ref(false); const errorMessageListing = ref('');
const loadingChart = ref(false); const errorMessageChart = ref('');
const dateParams = reactive({
    dateInf: '',
    heureInf: '',
    dateSup: '',
    heureSup: '',
});
const pagination = reactive({
    total: 0,
    per_page: 10,
    last_page: 1
});
const itemsList = ref([] as any[]);
const banques = ref([] as any[]);
const seriesChart = [
    { name: "Décaissements", data: [] },
    { name: "Utilisation", data: [] }
];
const summaryDatas = ref({
    total_decaissements: 0,
    total_transactions: 0
});

const optionsChart = {
    colors: ["#359b74", "#a559ed"],
    chart: { toolbar: { show: false } },
    dataLabels: { enabled: false },
    stroke: { curve: "smooth" },
    fill: { opacity: 0.3 },
    xaxis: { categories: ["Jan", "Fev", "Mar", "Avr", "Mai", "Jun"] }
};

onMounted(() => {
    doListTransactions();
    doGetChartDatas();
});
async function doListTransactions() {
    try {
        loadingListing.value = true;
        errorMessageListing.value = '';
        const queryParamsRaw = toRaw(queryParams);
        const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
        const httpResponse = await axios.get(`/backoffice/users/${props.userId}/utilisation/list_transactions?${queryString}`);
        banques.value = httpResponse.data.banques;
        const transactions = httpResponse.data.transactions;
        itemsList.value = transactions.data;
        pagination.total = transactions.total;
        pagination.per_page = transactions.per_page;
        pagination.last_page = transactions.last_page;
    } catch (error: any) {
        errorMessageListing.value = error.message;
    } finally {
        loadingListing.value = false;
    }
}
async function doGetChartDatas() {
    try {
        loadingChart.value = true;
        errorMessageChart.value = '';
        const queryParamsRaw = toRaw(queryParams);
        const queryString = new URLSearchParams(Object.fromEntries(Object.entries(queryParamsRaw).map(([k,v]) => [k, String(v)]))).toString();
        const httpResponse = await axios.get(`/backoffice/users/${props.userId}/utilisation/get_transactions_chart_datas?${queryString}`);
        seriesChart[0].data = httpResponse.data.transactions_chart_datas.map((d: any) => d.total_decaissements);
        seriesChart[1].data = httpResponse.data.transactions_chart_datas.map((d: any) => d.total_transactions);
        Object.assign(summaryDatas, {
            total_decaissements: httpResponse.data.transaction_summary_datas.total_decaissements,
            total_transactions: httpResponse.data.transaction_summary_datas.total_transactions
        });
    } catch (error: any) {
        errorMessageChart.value = error.message;
    } finally {
        loadingChart.value = false;
    }
}

function onDateParamsChanged() {
    let borneInf: any = null;
    if (dateParams.dateInf) {
        borneInf = dateParams.dateInf;
        if (dateParams.heureInf) { borneInf += `T${dateParams.heureInf}`; }
        const borneInfMoment = moment(borneInf);
        if (borneInfMoment.isValid()) {
            queryParams.borneInf = borneInfMoment.format('YYYY-MM-DD HH:mm');
        }
    }

    let borneSup: any = null;
    if (dateParams.dateSup) {
        borneSup = dateParams.dateSup;
        if (dateParams.heureSup) { borneSup += `T${dateParams.heureSup}`; }
        const borneSupMoment = moment(borneSup);
        if (borneSupMoment.isValid()) {
            queryParams.borneSup = borneSupMoment.format('YYYY-MM-DD HH:mm');
        }
    }
    
    doListTransactions();
}

function onPaginate(pageNumber: number) {
    queryParams.pageNumber = pageNumber;
    doListTransactions();
}

function onSelectBanque(banque_id: number | null) {
    queryParams.banque_id = banque_id;
    doListTransactions();
}
</script>
<template>
    <div class="s20 widget px-6 pt-8 pb-2">
        <div class="s10 mt--4 ml--4 mb-5 collapse-open active">
            <span class="px-5 py-4 bg-color-black rounded-100 text-xl">
                <img src="/icons/icon-panel-open.svg" class="size-xs icon-neutral mr-2 collapse-icon-open" alt="" />
                <img src="/icons/icon-panel-close.svg" class="size-xs icon-neutral mr-2 collapse-icon-close" alt="" />
                Transactions
            </span>
        </div>
        <div class="s10 mt--5-5 flex-right">
            <!-- <button class="btn lg py-3 white2 active">
                <img src="/icons/icon-consulter.svg" class="btn-icon" alt="" />
                <span>Utilisation</span>
            </button> -->
            <button class="btn lg py-3 black">
                <img src="/icons/icon-pdf.svg" class="btn-icon" alt="" />
                <span>Exporter en PDF</span>
            </button>
            <button class="btn lg py-3 black ">
                <img src="/icons/icon-excel.svg" class="btn-icon" alt="" />
                <span>Exporter en Excel</span>
            </button>
        </div>
        <div class="clear-both h-5"></div>

        <div class="s20 gap-6 px-4 pb-6 collapse-content active">
            <!--Frontoffice-->
            <!-- <div class="s13 flex gap-3 mb-5">
                <span class="btn light">Janvier</span>
                <span class="btn light2">Decembre</span>
                <span class="btn light2">Novembre</span>
                <span class="btn light2">Octobre</span>
                <span class="btn light2">Septembre</span>
            </div> -->
            <div class="s20 flex gap-3 mb-2">
                <div class="form-field-split my-4">
                    <div class="form-field-floating reactive search sm">
                        <input type="text" class="form-input" id="filters_search" v-model="queryParams.search" placeholder="" @keyup.enter="doListTransactions">
                        <label for="date1">Référence de transaction</label>
                    </div>
                </div>
                <div class="form-field-split my-4">
                    <div class="form-field-floating reactive sm">
                        <input type="date" class="form-input" v-model="dateParams.dateInf" placeholder="" @change="onDateParamsChanged">
                        <label for="date1">Date &lt;=</label>
                    </div>
                    <hr class="hr sm" />
                    <div class="form-field-floating reactive sm">
                        <input type="date" class="form-input" v-model="dateParams.dateSup" placeholder="" @change="onDateParamsChanged">
                        <label for="date2">Date &gt;=</label>
                    </div>
                </div>
                <div class="form-field-split my-4">
                    <div class="form-field-floating reactive sm">
                        <input type="time" class="form-input" v-model="dateParams.heureInf" placeholder="" @change="onDateParamsChanged">
                        <label for="time1">Heure &lt;=</label>
                    </div>
                    <hr class="hr sm" />
                    <div class="form-field-floating reactive sm">
                        <input type="time" class="form-input" v-model="dateParams.heureSup" placeholder="" @change="onDateParamsChanged">
                        <label for="time1">Heure &gt;=</label>
                    </div>
                </div>
            </div>
            <div class="s20 flex gap-3 mb-5">
                <span class="btn" :class="{'light': queryParams.banque_id == null, 'light2': queryParams.banque_id != null}" @click="onSelectBanque(null)">Tout</span>
                <span class="btn" :class="{'light': queryParams.banque_id == item.id, 'light2': queryParams.banque_id != item.id}" v-for="(item, index) of banques" :key="index" @click="onSelectBanque(item.id)">{{ item.nom }}</span>
            </div> 

            <div class="s20 flex gap-3 mb-5">
                <div class="s8">
                    
                    <template v-if="itemsList.length > 0">
                        <!--Transaction - Component-->
                        <div class="flex gap-6 mb-4" v-for="(item, index) of itemsList" :key="index">
                            <div class="square-xl px-4 py-4" style="background-color: rgba(0, 185, 172, 0.08);">
                                <img src="/icons/icon-trans-recharger.svg" width="100%" class="icon-neutral" />
                            </div>
                            <div class="s13 mt-2">
                                <h6 class="secondary-font font-semibold mb-1">Rechargement de ma carte a partir de mon wallet</h6>
                                <p class="secondary-font text-sm text-grey-600 mb-2">12 Mars 2024 à 14:32 - TCE441454</p>
                            </div>
                            <h5 class="s5 secondary-font text-right mt-2 text-green">+ 50 000 F</h5>
                        </div>
                        <!--End Transaction-->

                        <!--Pagination-->
                        <custom-pagination v-model="queryParams.pageNumber" :total="pagination.total" :per-page="pagination.per_page" :last_page="pagination.last_page" @update:modelValue="onPaginate" />
                        <!---->
                    </template>
                    
                    <template v-if="itemsList.length == 0">
                        <div class="text-center">
                            <h6 class="secondary-font font-semibold mb-1">Aucune transaction enregistrée</h6>
                        </div>
                    </template>
                </div>

                <div class="s2 flex-center"><hr class="hr-vertical h-500" /></div>

                <div class="s10 px-4 mt-2">
                    <div class="s10">
                        <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                            <div class="circle-medium bg-color-1000"></div>
                            Décaissement
                        </h5>
                        <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">{{ formatAmount(summaryDatas.total_decaissements) }} F</h1>
                        <!-- <h5 class="secondary-font font-semibold text-grey-700 mb-4">+5.4%</h5> -->
                    </div>
                    <div class="s10">
                        <h5 class="flex gap-3 secondary-font font-semibold text-grey-700">
                            <div class="circle-medium bg-purple"></div>
                            Utilisation
                        </h5>
                        <h1 class="secondary-font font-semibold text-grey-900 my-2 text-5xl">{{ formatAmount(summaryDatas.total_transactions) }} F</h1>
                        <!-- <h5 class="secondary-font font-semibold text-grey-700 mb-4">56.4%</h5> -->
                    </div>

                    <div class="clear-both h-30"></div>
                    <div>
                        <apexchart type="area" height="300" :options="optionsChart" :series="seriesChart"  />
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>